import React from 'react'
import times from 'lodash/times'
import Flex from 'components/ui/flex'
import Card from 'pages/insights/team/card'
import Skeleton from 'components/ui/skeleton'
type AggregatedStatItem = {
  uniqueListeners: number
  pageViews: number
  downloads: number
  streams: number
}
type Props = {
  loading: boolean
  isTrackSharingEnabled: boolean
  aggregatedStats?: AggregatedStatItem
}
export default function StatsSummary({
  loading,
  isTrackSharingEnabled,
  aggregatedStats,
}: Props): React.ReactNode {
  const numCards = isTrackSharingEnabled ? 4 : 3
  return loading ? (
    <Flex spacing="large">
      {times(numCards, (index: number) => (
        <Card key={index} title={<Skeleton />} value={<Skeleton />} />
      ))}
    </Flex>
  ) : (
    <Flex spacing="large">
      {isTrackSharingEnabled && (
        <Card
          title="Unique Listeners"
          value={aggregatedStats?.uniqueListeners}
          smallValueFont={true}
        />
      )}
      <Card
        title="Page Views"
        value={aggregatedStats?.pageViews}
        smallValueFont={true}
      />
      <Card
        title="Downloads/Saves"
        value={aggregatedStats?.downloads}
        smallValueFont={true}
      />
      <Card
        title="Streams"
        value={aggregatedStats?.streams}
        smallValueFont={true}
      />
    </Flex>
  )
}
